import axios from 'axios';
import configRepository from '../repositories/ConfigRepository';
import Vue from 'vue';

var RescheduleRepository = function () {
	
	var _config = configRepository.getConfig();
	
	function _callApi(action, model, desiredReadyDate) {

		var url = _config.endPointUrl + 'api/Terminal/' + action;

		// Creating a promise
		var promise = new Promise(function (resolve, reject) {
			// axios, for a full list of options see: https://github.com/axios/axios
			axios({
				method: 'POST',
				url: url,
				data: {
					'OrderId': model.id, 'DesiredReadyDate': desiredReadyDate
				},
				withCredentials: true
			}).then(function (response) {
				if (response.data.success) {
					response.data.data.firstDate = new Date(response.data.data.firstDate); 
					response.data.data.firstDateUtc = new Date(response.data.data.firstDateUtc); 
					resolve(response.data.data);
				}					
				else 
					reject(response.data.messages);
			}).catch(function (err) {
				window.console.log('#RescheduleRepository: Error calling ' + action + ' :' + err);
				reject(err);
			});
		});

		return promise;
    }

	var _data = {

		init: function () {
			
		},

		getEstimatedTime: function (order, desiredReadyDate) {
			return _callApi('GetEstimatedTime', order, desiredReadyDate);
		},

		reSchedule: function (order, desiredReadyDate) {
			return _callApi('ReSchedule', order, desiredReadyDate)
		}

	};
		
	_data.init();

	return _data;
}()

export { RescheduleRepository as default };